<template>
  <div class="main">
    <h1>This is the {{ moduleName }} module Home Page</h1>
    <h4>There are {{ getSubMenu().length }} sub modules in this module</h4>
    <div class="sub-modules">
      <div class="items" v-for="s in getSubMenu()" :key="s" @click="subModuleClick(s.ShortName)"
            data-toggle="tooltip" data-placement="top" :title="s.LongName">
        {{ s.ShortName }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  props: {
    moduleName: { type: String, default: '' }
  },
  methods: {
    getSubMenu: function() {
      return this.$subMenu.getList(this.moduleName);
    },
    subModuleClick: function(name) {
      $('[data-toggle="tooltip"]').tooltip('hide');
      this.$router.push(`/HomePage/${this.moduleName}/${name}`)
    }
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sub-modules {
  display: flex;
  justify-content: center;
  width: 50%;
  flex-wrap: wrap;
  // background-color: beige;
}

.sub-modules .items {
  background-color: white;
  padding: 10px;
  text-align: center;
  width: 150px;
  margin: 10px;
  font-weight: bold;
  font-size: 1.2em;
  border: 2px solid black;
  border-radius: 15px;
  transition: $transition-time;
}

.items:hover {
  cursor: pointer;
  background-color: black;
  color: white;
}
</style>